import React from 'react';
//  import { useFormik } from 'formik';
import styled from 'styled-components';
import LoginPage from './login';
import { Helmet } from 'react-helmet-async';
import { useContext } from 'react';
import { Context } from '../components/Context';

 const TimeClock = () => {
    const [context] = useContext(Context);
   // Pass the useFormik() hook initial form values, a validate function that will be called when
   // form values change or fields are blurred, and a submit function that will
   // be called when the form is submitted

if (context.isLoggedIn) {
    return (
        <Div>
            <Helmet>
                <meta 
                    name="description"  
                    content = "Big Dog Properties Timeclock"
                    />
    
                <title>Big Dog Properties | Timeclock</title>
            </Helmet>
            <p>bunch o stuff</p>
         </Div>
       );

  }
  return <LoginPage />;
 };

 export default TimeClock

 const getHeight = () => {
    if (window.innerWidth < 475) {
        return window.innerHeight * .35
    }
    else if (window.innerWidth >= 475 && window.innerWidth < 650) {
        return window.innerHeight * .5
    }
    else if (window.innerWidth >= 650 && window.innerWidth < 850) {
        return window.innerHeight * .7
    }
    else if (window.innerWidth >= 850 && window.innerWidth < 1050) {
        return window.innerHeight * .85
    }
    else{
        let height = window.innerHeight * .95;
        return height
    }
  }

const padding_height = () => {return  window.innerHeight * .35}

//  const Form = styled.form`
//     display:block;
//  `;
const Div = styled.div`
    width:100%;
    height:${getHeight}px;
    padding-top: ${padding_height}px;
    text-align:center;
    content-justify:center;
    align-items:center;
    // margin:100px;
    // padding:100px;
    // border: solid 2px orange;
`;


